<h4 align="center">BLOCKCHAIN E SMART CONTRACT:</h4>
<h5 align="center">teoria, programmazione e applicazioni</h5>
<br>
<h5>INFORMAZIONI GENERALI</h5>

<h6>Organizzatori</h6>
<p>Massimiliano Sala, Andrea Gangemi e Christopher Spennato.</p>

<h6>Lingua</h6>
<p>Italiano</p>

<h6>Costi</h6>
<p>Il corso è gratuito.</p>

<h6>Modalità di iscrizione</h6>
<p>L’esame può essere sostenuto esclusivamente da soci De Cifris. Le indicazioni per diventare socio sono disponibili
	alla seguente <a href="https://www.decifris.it/associarsi">pagina</a>. L’iscrizione al corso può essere effettuata
	dal <b>4 settembre al 2 ottobre 2023</b>, inviando una mail all’indirizzo <a
		href="mailto:y2y@decifris.it">y2y&#64;decifris.it</a>.</p>

<h6>Struttura del corso</h6>
<p>
	Il corso è diviso in 5 parti, ognuna composta da due lezioni online di due ore ciascuna. Le lezioni si svolgono ogni
	giovedì dalle 16 alle 18 dal 12 ottobre al 7 dicembre, mentre l'ultima lezione si svolgerà lunedì 11 dicembre,
	sempre dalle 16 alle 18.
</p>

<h6>Esame e certificato</h6>
<p>
	Alla fine del corso è possibile sostenere un esame orale online dopo il quale viene rilasciato un attestato di
	partecipazione al corso. L'esame è fissato al <b>15 Gennaio 2024</b>.
</p>

<h6>Contatti</h6>
<p>Per qualsiasi domanda inviare una mail a <a href="mailto:y2y@decifris.it">y2y&#64;decifris.it</a>.</p>


<h6> Programma</h6>
<div class="row">
	<div class="col-md-12">
		<table class="table table-striped">
			<thead>
				<tr>
					<th scope="col">Date</th>
					<th scope="col">Titolo</th>
					<th scope="col">Programma</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						12/10 e 19/10
					</td>
					<td>
						<p>
							<b>Introduzione alla blockchain</b> <br>
							Enrico Guglielmino & Andrea Flamini
						</p>
						<a href="../../../assets/images/events/2023/y2y/Blocco1.pdf">Slide</a> - YT video (<a
							href="https://youtu.be/FkRYxNQoN_c?si=fsjhOCfQCZ4ts4lK">Parte 1</a> + <a
							href="https://youtu.be/x2g-lcWrPxg?si=DaiPc-ZBZTiz_qd4">Parte 2</a>)
					</td>
					<td>
						Fondamenti di crittografia: <br>
						<ul>
							<li>Crittografia su Curve Ellittiche;</li>
							<li>Funzioni di hash;</li>
							<li>Firma digitale</li>
						</ul>
						Introduzione alla tecnologia blockchain:
						<ul>
							<li>Distributed Ledger Technology (DLT);</li>
							<li>Tipi di blockchain (permissionless /
								permissioned); Protocolli di consenso;</li>
							<li>Il Problema dei Generali Bizantini;</li>
							<li>Bizantine Fault;</li>
							<li>Tolerance (BFT);</li>
							<li>Catena di Proof-of-work;</li>
							<li>Il protocollo di consenso di Algorand</li>
						</ul>
				</tr>
				<tr>
					<td>
						26/10 e 02/11
					</td>
					<td>
						<p>
							<b>La blockchain di Bitcoin e i wallet</b> <br>
							Giorgio Rasetto
						</p>
						<a href="../../../assets/images/events/2023/y2y/Blocco2.pdf">Slide</a> - YT video (<a
							href="https://youtu.be/xbof5mgf0Aw?si=p24UcZbMIqWj9MDu">Parte 1</a> + <a
							href="https://youtu.be/quGd6dAB-_s?si=tfGJmyENRZaR_du-">Parte 2</a>)
					</td>
					<td>
						Bitcoin: <br>
						● Struttura del blocco; <br>
						● Crittografia di Bitcoin; <br>
						● Indirizzi Bitcoin; <br>
						● Wallets; <br>
						● Transazioni Bitcoin; <br>
						● Nodi Bitcoin; <br>
						● Verifica delle transazioni; <br>
						● Convalida del blocco e Fork; <br>
						● Creazione di Bitcoin; <br>
						● Difetti di Bitcoin; <br>
						● Lightning Network; <br>
					</td>
				</tr>
				<tr>
					<td>
						09/11 e 16/11
					</td>
					<td>
						<p>
							<b>Introduzione alla blockchain Ethereum, oracoli e applicazioni</b>
							Andrea Gangemi
						</p>
						<a href="../../../assets/images/events/2023/y2y/Blocco3.pdf">Slide</a> - YT video (<a
							href="https://youtu.be/fmhXk1Xl38A?si=jL67suCH-MVzdI32">Parte 1</a> + <a
							href="https://youtu.be/SZQODxWO29Q?si=lAkgedxuNXjH6v34">Parte 2</a>)
					</td>
					<td>
						Ethereum: <br>
						● Ethereum Virtual Machine (EVM) <br>
						● Smart contracts <br>
						● La crittografia e gli address Ethereum; <br>
						● Transazioni; <br>
						● Protocollo di consenso; <br>
						● Token fungibili e token non fungibili; <br>
						● Oracoli; <br>
						● DApps e DAO; <br>
						● DeFi, ICO e STO; <br>
						● Un approfondimento: i rollup come
						soluzione di scalabilità; <br>
					</td>
				</tr>
				<tr>
					<td>
						23/11 e 30/11
					</td>
					<td>
						<p>
							<b>Utilizzo dei wallet e programmazione con Solidity</b> <br>
							Christopher Spennato
						</p>
						<a href="../../../assets/images/events/2023/y2y/Blocco4.pdf">Slide</a> - YT video (<a
							href="https://youtu.be/uf4Z2pLhwR0?si=dGjCqZkKjfp3xrMw">Parte 1</a> + <a
							href="https://youtu.be/XzYqsmg5XsE?si=sBv5Tj_CsAVtUqWm">Parte 2</a>)
					</td>
					<td>
						MetaMask: <br>
						● User-experience e Installazione su browser; <br>
						● Funzionalità di MetaMask; <br>
						● Utilizzo di MetaMask SDK (tramite React):
						Collegamento di MetaMask a una Dapp; <br>
						Solidity: <br>
						● Basi sintattiche e logiche di Solidity: <br>
						● Come creare smart contract: <br>
						<ul>
							<li>Utilizzare l’IDE Remix; </li>
							<li>
								Eseguire transazioni su blockchain;
							</li>
							<li>Scrittura di alcuni codici passo
								passo;</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>
						7/12 e 11/12
					</td>
					<td>
						<p>
							<b>Applicazioni della blockchain</b>
						</p>
						<a href="../../../assets/images/events/2023/y2y/Blocco5.pdf">Slide</a> - YT video (<a
							href="https://youtu.be/AqzhgcoLxJI?si=oChXDUq-6V_-xJfg">Parte 1</a> + <a
							href="https://youtu.be/df57A25fs4M?si=17gPBjh8dpo27nju">Parte 2</a>)
					</td>
					<td>
						Applicazioni: <br>
						<ul>
							<li>Introduzione alle applicazioni;</li>

							<li>Contract Lifecycle Management (CLM);</li>

							<li>Automotive;</li>

							<li>Voto elettronico;</li>

							<li>Raccolta differenziata e impronta ecologica;</li>

							<li>Charity;</li>

							<li>Decentralzied Identifiers;</li>

							<li>Digital Notary;</li>

							<li>Dhali.</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>